import Toast from "@/common/components/ui/toast"
import Dashboard from "@/common/components/layout/Dashboard"
import { ToastProvider } from "@/common/components/ui/toast/toast.provider"
import TableDevolutionDeposit from "./components/TableDevolutionDeposit"


export default function DevolutionDepositPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableDevolutionDeposit />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}
